export default "__VITE_ASSET__7hANbKS9__"